import { useCallback, useMemo } from 'react';
import { sendActionToDatadog } from '../../Datadog';
import { PERFORMANCE_MEASURE_NAMES } from '../config/constants';
var usePerformanceLoggerForRemote = function (remote) {
    var createActionLogger = useCallback(function (actionName) { return function (time) { return sendActionToDatadog(actionName, { time: time, remote: remote }); }; }, [remote]);
    var onLoad = useMemo(function () { return createActionLogger(PERFORMANCE_MEASURE_NAMES.REMOTE_LOADED); }, [
        createActionLogger,
    ]);
    var onModuleEvaluation = useMemo(function () { return createActionLogger(PERFORMANCE_MEASURE_NAMES.MODULE_EVALUATION_COMPLETED); }, [createActionLogger]);
    return {
        onLoad: onLoad,
        onModuleEvaluation: onModuleEvaluation,
    };
};
export default usePerformanceLoggerForRemote;
//# sourceMappingURL=usePerformanceLoggerForRemote.js.map